import { Conversation } from "../models/Conversation";
import { clean } from "../utils/utils";
import api from "./api";
import { Message } from "../models/Message";
import { User } from "../models/User";
import { Matter } from "../models/Matter";

const PATH = "/api/v1/conversations";

export const ConversationService = {
  async createConversation(conversationData: {
    subject: string;
    userIds: User["_id"][];
    matterId: Matter["_id"];
  }): Promise<string> {
    const response = await api.post(PATH, clean(conversationData));
    return response.data.data._id;
  },

  async getAllConversations(): Promise<Conversation[]> {
    const response = await api.get(PATH);
    return response.data.data || [];
  },

  async getConversation(conversationId: string): Promise<Conversation> {
    const response = await api.get(`${PATH}/${conversationId}`);
    return response.data.data;
  },

  async getMessages(conversationId: string): Promise<Message[]> {
    const res = await api.get(`${PATH}/${conversationId}/messages`);
    return res.data.data || [];
  },

  async updateConversation(
    conversationId: string,
    updatedData: Partial<Omit<Conversation, "_id" | "createdAt">>,
  ): Promise<void> {
    await api.put(`${PATH}/${conversationId}`, clean(updatedData));
  },

  async deleteConversation(conversationId: string): Promise<void> {
    await api.delete(`${PATH}/${conversationId}`);
  },
};
